import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { List, X, ArrowUpRight } from '@phosphor-icons/react';
import { BrandLogo } from './BrandLogo';

const links = [
  { to: '/', label: 'Trang chủ', end: true },
  { to: '/recipes', label: 'Công thức', end: false },
  { to: '/about', label: 'Về SUII', end: false },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  const container = useRef<HTMLElement>(null);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    if (!open) return;
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); toggle.current?.focus(); }
    };
    const outside = (event: PointerEvent) => {
      if (!container.current?.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener('keydown', keydown);
    document.addEventListener('pointerdown', outside);
    return () => { document.removeEventListener('keydown', keydown); document.removeEventListener('pointerdown', outside); };
  }, [open]);
  return <header className="site-header" ref={container}>
    <div className="header-inner">
      <Link className="wordmark" to="/" aria-label="SUiiLife — Trang chủ"><BrandLogo /></Link>
      <nav className="desktop-navigation" aria-label="Điều hướng chính">
        {links.map(link => <NavLink key={link.to} to={link.to} end={link.end}>{link.label}</NavLink>)}
      </nav>
      <Link className="header-note" to="/recipes/">Góc bếp của bạn <ArrowUpRight size={16} /></Link>
      <button ref={toggle} className="mobile-menu-toggle icon-control" aria-label={open ? 'Đóng menu' : 'Mở menu'} aria-controls="mobile-navigation" aria-expanded={open} onClick={() => setOpen(value => !value)}>{open ? <X size={24} /> : <List size={25} />}</button>
    </div>
    {open && <nav id="mobile-navigation" className="mobile-navigation" aria-label="Điều hướng trên điện thoại">
      {links.map(link => <NavLink key={link.to} to={link.to} end={link.end} onClick={() => setOpen(false)}>{link.label}<ArrowUpRight size={20} /></NavLink>)}
    </nav>}
  </header>;
}
